import { Platforms } from '../../types'

export enum DocumentActions {
  SLICE_NAME = 'closeDocuments',
  FETCH_DOCUMENTS = 'closeDocuments/fetchDocuments',
  UPDATE_DOCUMENTS = 'closeDocuments/updateDocuments',
}

export interface IFileItem {
  download_url: string
  id: string
  is_downloaded: boolean
  platform: Platforms
  month: string
}

export interface IDocument {
  month: string
  acts: IFileItem[]
  invoices: IFileItem[]
}

export interface IDocumentsList {
  count: number
  current: number
  next: number | null
  page_count: number
  previous: number | null
  results: IDocument[]
  loading: boolean
}

export interface IDocumentsState {
  documentsList: IDocumentsList
}
